import React from 'react';
import { Link } from 'react-router-dom';
import { RiArrowRightSLine } from 'react-icons/ri';
import './Featured.scss';
import FeaturedMovie from './FeaturedMovie';

const Featured = () => {
    return (
        <div className="featured" id="featured">
            <section className="featured-section">
                <div className="featured-header">
                    <Link to="/trending-movies" className="featured-header-link">
                        Trending <span><RiArrowRightSLine /></span>
                    </Link>
                </div>
                <div className="featured-movies">
                    <FeaturedMovie />
                </div>
            </section>
        </div>
    )
}

export default Featured;
